// Authed download helper for binary responses. The server-side handler also
// fires a bot.SendDocument as a side effect, so this is the "visible" path on
// the web while the bot delivery is the "visible" path inside Telegram (where
// the iframe sandbox silently blocks blob downloads). Whichever environment
// the user is in, one of the two paths surfaces the file.
export async function downloadAuthed(url, btn) {
	const token = window.TelegramSession;
	if (!token) {
		console.error('downloadAuthed: no session token');
		return;
	}

	if (btn) btn.classList.add('htmx-request');

	try {
		const resp = await fetch(url, {
			headers: { 'Authorization': 'Bearer ' + token },
		});

		if (!resp.ok) {
			console.error('downloadAuthed: request failed', resp.status);
			if (resp.status === 401) {
				const next = window.location.pathname + window.location.search;
				window.location.href = '/login?next=' + encodeURIComponent(next);
			}
			return;
		}

		const blob = await resp.blob();
		const cd = resp.headers.get('content-disposition') || '';
		const match = cd.match(/filename="?([^"]+)"?/);
		const filename = match ? match[1] : 'download.pdf';

		const objectUrl = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = objectUrl;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		a.remove();
		URL.revokeObjectURL(objectUrl);
	} finally {
		if (btn) btn.classList.remove('htmx-request');
	}
}